import "./loader.css";

const Loader = () => {
  return (
    <div className="spinner">
      <div className="spinner_round"></div>
    </div>
  );
};

export default Loader;
